import { render, staticRenderFns } from "./ChangeModule.vue?vue&type=template&id=9cc2bd98&scoped=true&"
import script from "./ChangeModule.vue?vue&type=script&lang=js&"
export * from "./ChangeModule.vue?vue&type=script&lang=js&"
import style0 from "./ChangeModule.vue?vue&type=style&index=0&id=9cc2bd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc2bd98",
  null
  
)

export default component.exports